<script lang="ts" setup>
import { definePageMeta } from '#imports'
import Desktop from '~desktop/pages/home/index.vue'
import Mobile from '~mobile/pages/home/index.vue'
import { usePageByDevice } from '~/composables/common/use-page-by-device'
definePageMeta({
  pageTransition: {
    mode: 'default'
  }
})
const { component } = usePageByDevice(Desktop, Mobile)
</script>

<template>
  <div>
    <component :is="component" />
  </div>
</template>
